var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#899AA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3825 3.60417C10.9919 3.21365 10.3588 3.21365 9.96826 3.60417L7.49178 6.08065L5.02925 3.61812C4.6396 3.22847 4.00786 3.22847 3.61822 3.61812C3.22857 4.00776 3.22857 4.6395 3.61822 5.02915L6.08075 7.49168L3.60429 9.96813C3.21377 10.3587 3.21377 10.9918 3.60429 11.3823C3.99482 11.7729 4.62798 11.7729 5.01851 11.3823L7.49496 8.90589L9.98536 11.3963C10.375 11.7859 11.0067 11.7859 11.3964 11.3963C11.786 11.0066 11.786 10.3749 11.3964 9.98527L8.90599 7.49486L11.3825 5.01839C11.773 4.62786 11.773 3.9947 11.3825 3.60417Z",
    fill: "#DBDFE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b53dbedecb8b4469d593624afd434092.svg";
export { ForwardRef as ReactComponent };